// import React, { useState } from "react";
import { useParams } from "react-router-dom";
import LogsTab from "../LogsTab";

const GunLogDetails = ({ logs = [] }) => {
  const { lognum } = useParams(); // get log number from URL
  // const [currentTab, setCurrentTab] = useState("pecc"); // internal tab state

  return (
    <div className="flex h-screen w-full max-w-full overflow-hidden">
      {/* Main Content */}
      <div className="min-w-0 flex-1 p-2 flex flex-col space-y-4 overflow-x-hidden overflow-y-auto">
        {/* Page Title */}
        <div className="text-center rounded-xl  bg-white flex items-start justify-start">
          <h1 className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-800">
            Gun Parameters - Log {lognum}
          </h1>
        </div>
        <LogsTab lognum={lognum} />
        <div className="flex flex-col flex-1 min-h-0">
         
        </div>
      </div>
    </div>
  );                                                                                                                                                                                                                                                                                  
};

export default GunLogDetails;
